import AjaxForm from "../AjaxForm";
import PatientFields from "./PatientFields";
import ConsultantFields from './ConsultantFields';
import {DosageArithmetic} from './DosageArithmetic';
import 'selectize';

export default class PatientRequestForm extends AjaxForm
{

    init() {
        super.init();

        this.registerSelectors();
        this.bindEvents();

        this.subsequentDoseFieldsSelector = [
            'MaintenanceDosage',
            'MaintenanceDosageFrequency',
            'DosageDuration',
            'SubsequentApprovedProduct',
            'AbsoluteMainteanceDose',
            'MaintenanceDoseVialRounding',
            'AbsoluteMainteanceDose',
            'MaintenanceDoseRounding',
        ].map(name => '#'.concat(name)).join(', ');

        this.initialDosageArithmetic = new DosageArithmetic(
            this,
            'DosageInitial',
            'AbsoluteInitialDailyDose',
            'InitialApprovedProduct',
            'InitialDoseRounding',
            'DosageSpreadOver',
            'g/d'
        );

        this.maintenanceDosageArithmetic = new DosageArithmetic(
            this,
            'MaintenanceDosage',
            'AbsoluteMainteanceDose',
            'SubsequentApprovedProduct',
            'MaintenanceDoseRounding',
        );

        this.initialDosageArithmetic.init();
        this.maintenanceDosageArithmetic.init();

        this.loadComponents();

        // This is a bit of a dirty hack to make sure the Maintenance dose doesn't get unset when determining if the
        // Maintenance Dose field should start shown or hidden.
        this.firstSubsequentToogle = true;

        // check when form first loads
        this.toggleConsultantFields();

        //add disabled on the filed by js
        $(".edit-disable").each(function(){
            $(this).attr('disabled','disabled');
        });

        // Stop native browser action autocomplete input
        $('input').attr('autocomplete', 'off');

    }

    /**
     * Load sub-components
     */
    loadComponents() {
        this.patientFields = new PatientFields(this.childElements('.patient-fields'));
        this.patientFields.setLookupUrl(this.getPatientLookupUrl()).init();

        if (this.childElements('.consultant-fields').length > 0) {
            // The Consultant field is not avilable on the Patient Request Review Form.
            this.consultantFields = new ConsultantFields(this.childElements('.consultant-fields'));
            this.consultantFields.setLookupUrl(this.getConsultantLookupUrl()).init();
        }
        this.setUpConditionDropDown()

        this.initialDosageArithmetic.refresh();
        this.maintenanceDosageArithmetic.refresh();

        this.toogleInitialPeerReviewField();
        this.toggleIbwFields();
    }

    setUpConditionDropDown() {
        const container = this.element.find('#ConditionID');
        container.find('select')
            .selectize({ sortField: 'text' })
    }

    /**
     * Update sub-components after the form has been refreshed.
     */
    refreshComponents() {
        this.loadComponents();
    }

    /**
     * Setup css selectors used
     */
    registerSelectors() {
        // select a condition
        this.conditionFieldSelector = 'select[name=ConditionID]';
        // options for maintenance doses
        this.subsequentDosageRequiredSelector = 'input[name=MaintenanceDosageDoseRequired]';

        // select registrar or consultant
        this.accountTypeSelector = 'input[name="Clinician[Responsible]"]';
        // select Initial peer review text area
        this.initialPeerReviewSelector = 'textarea[name=InitialPeerReview]';

        //transfer consultant action
        this.transferConsultantAction = 'button[name=action_TransferConsultant]';

        //force review action
        this.forceReviewAction = 'button[name=action_InitiateReview]';

        this.optOutIbwSelector = 'select[name=OptOutIbw]';
        this.optOutIbwField = '#OptOutIbwReason';
    }

    /**
     * Setup event listeners
     */
    bindEvents() {
        // ibw
        this.element.on('change', this.optOutIbwSelector, () => this.toggleIbwFields());

        // dosage
        this.element.on('change', this.subsequentDosageRequiredSelector, () => this.toggleSubsequentFields());
        // condition
        this.element.on('change', this.conditionFieldSelector, () => this.loadConditionCriteriaFields());
        // account fields
        this.element.on('change', this.accountTypeSelector, () => this.toggleConsultantFields());
        // initial Peer Review change
        this.element.on('change', this.initialPeerReviewSelector, this.toogleInitialPeerReviewField.bind(this));

        // redirect to transfer form
        this.element.on('click', this.transferConsultantAction, (e) => this.redirectTransferForm(e));

        //force a review
        this.element.on('click', this.forceReviewAction, (e) => this.redirectReview(e));
    }

    toggleIbwFields() {
        const toggleFields = this.childElements(this.optOutIbwField);
        const ibwToggle = this.childElements(this.optOutIbwSelector);

        if (ibwToggle.length == 0 || ibwToggle.val() == 1) {
            toggleFields.show();
            toggleFields.find('select, input')
                .attr('data-parsley-required', 'true')
                .attr('required', 'required')

        } else {
            toggleFields.hide();
            toggleFields.find('select, input')
                .removeAttr('data-parsley-required')
                .removeAttr('required');

        }
    }

    /**
     * Show extra fields if SubsequentDose is true, hide otherwise
     */
    toggleSubsequentFields() {
        const toggleFields = this.childElements(this.subsequentDoseFieldsSelector);
        const maintanceDoseToogle = this.childElements(this.subsequentDosageRequiredSelector) ;

        if (maintanceDoseToogle.length == 0 || maintanceDoseToogle.filter(':checked').val() == 1) {
            toggleFields.show();
            toggleFields.find('select, input')
                .attr('data-parsley-required', 'true')
                .attr('required', 'required')

            // IF this is the very first run, let's not trigger the change or we'll unset the rounding field
            this.firstSubsequentToogle || toggleFields.find('select, input').trigger('change');

            // That field is not required
            this.childrenByName('MaintenanceDoseRounding').removeAttr('data-parsley-required').removeAttr('required')
        } else {
            toggleFields.hide();
            //Explicitely unset the subsequent product.
            this.childrenByName('SubsequentApprovedProduct').val('');
            toggleFields.find('select, input')
                .removeAttr('data-parsley-required')
                .removeAttr('required');

            this.firstSubsequentToogle || toggleFields.find('select, input').trigger('change');

        }

        this.firstSubsequentToogle = false;
    }

    /**
     * Show fields for account if registrar is submitting
     */
    toggleConsultantFields() {
        // Patient Review request don't have a consultant field.
        if (!this.consultantFields) {
            return;
        }

        let selector = this.childElements(this.accountTypeSelector).filter(':checked'),
            val = selector.val();

        // do nothing if there is no account type field
        if (!selector.length) {
            return;
        }

        if (val === 'DifferentConsultant') {
            this.consultantFields.show();
        } else {
            this.consultantFields.hide();
        }
    }

    /**
     * Don't validate the initial peer review by field if no initial peer review is provided.
     */
    toogleInitialPeerReviewField() {
        const initPeerReviewBy = this.childElements('[name=InitialPeerReviewBy]');

        if (this.childElements(this.initialPeerReviewSelector).val() != '') {
            initPeerReviewBy.attr('data-parsley-required', 'true').attr('required', 'required');
        } else {
            initPeerReviewBy.removeAttr('data-parsley-required').removeAttr('required');
        }
    }

    redirectTransferForm(e){
        e.preventDefault();
        let url = $(e.target).closest(this.transferConsultantAction).data('url');
        window.location.href = url;
    }

    redirectReview(e){
        e.preventDefault();
        let url = $(e.target).closest(this.forceReviewAction).data('url');
        console.log(url);
        window.location.href = url;
    }

    /**
     * Loads criteria fields based on the selected condition.
     *
     * Data is loaded through ajax through url set on data attribute on the form.
     */
    loadConditionCriteriaFields() {
        let condition = this.childElements(this.conditionFieldSelector).val(),
            container = this.childElements('.criteria-fields'),
            row = this.childElements('.criteria-fields .row');

        container.addClass('loading');
        $.get(this.getConditionCriteriaUrl() + '/' + condition)
            .done((response) => {
                container.removeClass('loading');

                if (response.status) {
                    row.html(response.html);
                    this.addCriteriaValidation();
                    this.afterRefresh(row);
                } else {
                    row.html('<p class="error col-sm-12">' + response.message + '</p>')
                }
            });
    }

    /**
     * Add validation to criteria fields
     */
    addCriteriaValidation()
    {
        this.childElements('[name="Criteria[*]"]').each((index, el) => {
            $(el).attr('data-parsley-required', true)
        });

        this.validator._refreshFields();
    }

    /**
     * Gets the url for loading criteria fields for the selected condition.
     */
    getConditionCriteriaUrl() {
        return this.element.data('condition-criteria-url');
    }

    /**
     * Gets the url to lookup a consultant.
     *
     * @return {string}
     */
    getConsultantLookupUrl() {
        return this.element.data('consultant-lookup-url');
    }

    /**
     * Gets the url to lookup a patients details by nhi.
     *
     * @return {string}
     */
    getPatientLookupUrl() {
        return this.element.data('patient-lookup-url');
    }

    /**
     * Add calendar to after refresh.
     *
     * @param {HTMLElement} element
     */
    afterRefresh(element) {
        // Let's treat this load like the very first one and make sure we don't unset the rounding.
        this.firstSubsequentToogle = true;

        if (!element) {
            element = this.element;
            // only refresh when whole form is refreshed
            this.refreshComponents();
        }

        super.afterRefresh(element);
    }

    /**
     * Massage the data a bit before sending it back to the server
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    handleSubmit(e) {
        // If the Responsible clinician is set to be the requesting clinician, the explicitly set the ConsultantID
        // field to the RequestingClinicianID
        if (this.childElements('#TreatmentForm_Form_Clinician_Responsible_Clinician').is(':checked')) {
            const consultantField = this.childElements('[name="ConsultantID"]');
            const requestingClinicianID = this.childElements('[name="RequestingClinicianID"]').val();
            consultantField.find('option').remove();
            consultantField.append($('<option selected/>').val(requestingClinicianID));
        }
        super.handleSubmit(e);
    }

}
